package com.essntl.features.invoice.ui.allinvoice

import com.essntl.core.quickbooks.data.QuickbooksInvoice
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.invoice.domain.model.InvoiceModel

data class InvoiceState(
    val getAllInvoices: State<List<InvoiceModel>> = State(),
    val getAllQuickbooksInvoices: State<List<QuickbooksInvoice>> = State.loading(),
    val loadingShareQuickbookIds: Set<String> = emptySet(),
    val loadingDownloadQuickbookIds: Set<String> = emptySet(),
    val downloadQuickbooksInvoice: State<Pair<String, QuickbooksInvoice>> = State(),
)
